import { api } from "./api";

// --- Read ---
export const powerHome = () => api.get("/power/petitions/home").then((r) => r.data);
export const powerCategories = () => api.get("/power/categories").then((r) => r.data);
export const powerList = (params = {}) => api.get("/power/petitions", { params }).then((r) => r.data);
export const powerGet = (slug) => api.get(`/power/petitions/${slug}`).then((r) => r.data);

// --- Write ---
export const powerCreate = (payload) => api.post("/power/petitions", payload).then((r) => r.data);
export const powerSign = (slug, payload) => api.post(`/power/petitions/${slug}/sign`, payload).then((r) => r.data);
export const powerBookmarkToggle = (slug) => api.post(`/power/petitions/${slug}/bookmark`).then((r) => r.data);

// --- Me ---
export const powerMyProfile = () => api.get("/power/me/profile").then((r) => r.data);
export const powerMyBookmarks = () => api.get("/power/me/bookmarks").then((r) => r.data);
export const powerMyCreated = () => api.get("/power/me/created").then((r) => r.data);
export const powerMySigned = () => api.get("/power/me/signed").then((r) => r.data);

// --- Wallet ---
export const powerWallet = () => api.get("/power/wallet").then((r) => r.data);
export const powerWalletHistory = () => api.get("/power/wallet/history").then((r) => r.data);
export const powerWithdraw = (payload) => api.post("/power/wallet/withdraw", payload).then((r) => r.data);

// --- Phase 20B: Rewards / XP / Referrals / Leaderboard / Achievements ---
export const powerRewardsStatus = () => api.get("/power/rewards/status").then((r) => r.data);
export const powerCheckin      = () => api.post("/power/rewards/checkin").then((r) => r.data);
export const powerWatchAd      = () => api.post("/power/rewards/watch-ad").then((r) => r.data);
export const powerMyXp         = () => api.get("/power/me/xp").then((r) => r.data);
export const powerAchievements = () => api.get("/power/achievements").then((r) => r.data);
export const powerLeaderboard  = (scope = "xp") => api.get("/power/leaderboard", { params: { scope } }).then((r) => r.data);
export const powerMyReferrals  = () => api.get("/power/referrals/me").then((r) => r.data);
export const powerRedeemReferral = (code) => api.post("/power/referrals/redeem", { code }).then((r) => r.data);

// --- Phase 20B: Comments / Updates / Media / Promote ---
export const powerComments      = (slug, params = {}) => api.get(`/power/petitions/${slug}/comments`, { params }).then((r) => r.data);
export const powerComment       = (slug, body) => api.post(`/power/petitions/${slug}/comments`, { body }).then((r) => r.data);
export const powerCommentDelete = (cid) => api.delete(`/power/comments/${cid}`).then((r) => r.data);
export const powerUpdates       = (slug) => api.get(`/power/petitions/${slug}/updates`).then((r) => r.data);
export const powerUpdate        = (slug, payload) => api.post(`/power/petitions/${slug}/updates`, payload).then((r) => r.data);
export const powerMediaList     = (slug) => api.get(`/power/petitions/${slug}/media`).then((r) => r.data);
export const powerMediaAdd      = (slug, payload) => api.post(`/power/petitions/${slug}/media`, payload).then((r) => r.data);
export const powerPromotePlans  = () => api.get("/power/promote/plans").then((r) => r.data);
export const powerPromote       = (slug, plan_id) => api.post(`/power/petitions/${slug}/promote`, { plan_id }).then((r) => r.data);
export const powerPromotion     = (slug) => api.get(`/power/petitions/${slug}/promotion`).then((r) => r.data);

// --- Phase 20B: Power Admin ---
export const powerAdminConfig       = () => api.get("/admin/power/config").then((r) => r.data);
export const powerAdminUpdateConfig = (payload) => api.patch("/admin/power/config", payload).then((r) => r.data);
export const powerAdminWithdrawals  = (status = "pending") => api.get("/admin/power/withdrawals", { params: { status } }).then((r) => r.data);
export const powerAdminApproveW     = (wid) => api.post(`/admin/power/withdrawals/${wid}/approve`).then((r) => r.data);
export const powerAdminRejectW      = (wid) => api.post(`/admin/power/withdrawals/${wid}/reject`).then((r) => r.data);
export const powerAdminFraud        = () => api.get("/admin/power/fraud").then((r) => r.data);
export const powerAdminStats        = () => api.get("/admin/power/stats").then((r) => r.data);

export const POWER_CATEGORIES = [
  "Government", "Animals", "Human Rights", "Public Safety", "Education",
  "Healthcare", "Technology", "Environment", "Crime", "Politics",
  "Schools", "Housing", "Employment", "Transportation", "Veterans",
  "Local Community", "Justice", "Consumer Rights", "Business", "Other",
];

// Compact number: 74210 -> "74.2K"
export const compactNumber = (n) => {
  n = Number(n) || 0;
  if (n < 1000) return String(n);
  if (n < 1_000_000) return `${(n / 1000).toFixed(n < 10_000 ? 1 : 0).replace(/\.0$/, "")}K`;
  return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
};
